import { Button, Checkbox } from '@scholastic/mockingjay';
import { useState, type FormEvent } from 'react';
import { useAccessCodeRedemptionContext } from './AccessCodeRedemptionContext';
import { useConfirmRedemptionSubmit } from './use-confirm-redemption-submit';

const PRODUCT_TERMS_URL =
  'https://digital.scholastic.com/resources/js/Modules/licenseAccept/licenseAcceptPDF/ProductTerms.pdf';
const INDIVIDUAL_CUSTOMER_AGREEMENT_URL =
  'https://digital.scholastic.com/resources/js/Modules/licenseAccept/licenseAcceptPDF/IndividualCustAgreement.pdf';

export function TermsAgreementLabel() {
  return (
    <span className="text-base">
      I have read and accept the{' '}
      <a
        className="text-blue-700 underline"
        href={PRODUCT_TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Product Terms
        <span className="sr-only"> (opens in new tab)</span>
      </a>{' '}
      and{' '}
      <a
        className="text-blue-700 underline"
        href={INDIVIDUAL_CUSTOMER_AGREEMENT_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        Individual Customer Agreement
        <span className="sr-only"> (opens in new tab)</span>
      </a>
      .
    </span>
  );
}

export function ConfirmRedemption() {
  const [isChecked, setIsChecked] = useState(false);
  const { redemptionData } = useAccessCodeRedemptionContext();
  const { handleSubmit: submitRedemption, isPending } =
    useConfirmRedemptionSubmit();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await submitRedemption();
  };

  if (!redemptionData.product) {
    return null;
  }

  return (
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    <form onSubmit={handleSubmit} className="flex flex-col gap-14">
      <div className="flex flex-col gap-6 text-lg text-neutral-900">
        <p>
          You have redeemed the access code for{' '}
          <strong className="font-bold">
            {redemptionData.product.productName}!
          </strong>
        </p>
        <img
          src={redemptionData.product.thumbnailUrl}
          alt={redemptionData.product.productName}
          className="h-full max-h-11 w-fit object-scale-down"
        />
        <p>
          You must accept the product terms and the individual customer
          agreement before we can continue your setup.
        </p>
        <Checkbox
          checked={isChecked}
          onCheckedChange={(checked) => setIsChecked(!!checked)}
          label={
            /* @ts-expect-error need to fix type in mockingjay */
            (<TermsAgreementLabel />) as string
          }
        />
      </div>

      <div className="flex justify-end">
        <Button
          type="submit"
          variant="primary"
          disabled={!isChecked || isPending}
        >
          Next
        </Button>
      </div>
    </form>
  );
}
